import React from "react";
import styles from "./CareerPath.module.css";
import { Check } from "lucide-react";

interface CareerPathProps {
  data: {
    title?: string;
    career_list: Array<{ id?: number; item?: string }>;
  };
}

const CareerPath: React.FC<CareerPathProps> = ({ data }) => {
  return (
    <div className={styles.careerPathContainer}>
      {data?.career_list && <h2 className={styles.heading}>{data?.title}</h2>}
      <div className={styles.gridContainer}>
        {data?.career_list?.map((career) => (
          <div key={career?.id} className={styles.gridItem}>
            <Check className={styles.icon} />
            <span className={styles.text}>{career?.item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CareerPath;
